import { faArrowLeft, faArrowRight } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useEffect } from 'react';
import './calendar-toolbar.scss';
import { Badge } from 'reactstrap';

export const CalendarToolbar = (props: any) => {
    const goToBack = () => {
        let mDate = new Date(props.date);
        props.onNavigate('PREV', mDate);
    };

    const goToNext = () => {
        let mDate = new Date(props.date);
        props.onNavigate('NEXT', mDate);
    };

    const missedEventsFlag = (
        missedEvents: number,
        position: 'right' | 'left'
    ) => {
        return missedEvents > 0 ? (
            <Badge className={`unread-events-badge-${position}`}>
                {missedEvents > 9 ? '9+' : missedEvents}
            </Badge>
        ) : (
            <></>
        );
    };

    return (
        <div className="rbc-toolbar calendar-toolbar">
            <span className="rbc-btn-group">
                <button type="button" onClick={goToBack}>
                    {missedEventsFlag(
                        props.notificationFlagsOnPreviousPages,
                        'left'
                    )}
                    <FontAwesomeIcon icon={faArrowLeft} /> Back
                </button>
                <button type="button" onClick={goToNext}>
                    Next <FontAwesomeIcon icon={faArrowRight} />
                    {missedEventsFlag(
                        props.notificationFlagsOnNextPages,
                        'right'
                    )}
                </button>
            </span>
            <span className="rbc-toolbar-label">{props.label}</span>
        </div>
    );
};
